/**
 * returns the iqr of a given string of numbers
 * @param data string of numbers
 * @returns iqr of param array
 */
export const removeOutliers = (data: number[]): number[] => {
	const sortedData = [...data].sort((a, b) => a - b);
	const getPercentile = (arr: number[], p: number) => {
		const index = (arr.length - 1) * p;
		const lower = Math.floor(index);
		const upper = Math.ceil(index);
		const weight = index - lower;
		return arr[lower] * (1 - weight) + arr[upper] * weight;
	};
	const q1 = getPercentile(sortedData, 0.25);
	const q3 = getPercentile(sortedData, 0.75);

	const iqr = q3 - q1;
	const lowerBound = q1 - 1.5 * iqr;
	const upperBound = q3 + 1.5 * iqr;

	return data.filter((x) => x >= lowerBound && x <= upperBound);
};
